import { JobPostingDetailsForm } from '../JobBoardsTabUI/JobPostingDetails';

const FORM_OPTIONAL_FIELDS = [
  'address2',
  'companyId',
  'remote',
  'contactName',
  'contactEmail',
  'contactPhone',
  'salaryPeriod',
  'salaryCurrency',
  'salaryRangeFrom',
  'salaryRangeTo',
  'weeklyHoursFrom',
  'organicEnabled',
];

export function isSalaryFilled(form: JobPostingDetailsForm): boolean {
  return !!(form.salaryPeriod || form.salaryRangeTo || form.salaryRangeFrom);
}

function validateSalaryCurrency(form: JobPostingDetailsForm): boolean {
  if (isSalaryFilled(form)) {
    return !!form.salaryCurrency;
  }

  return true;
}

export function formIsValid(
  form: JobPostingDetailsForm,
  optionalFields?: string[],
): boolean {
  if (form == null) {
    return false;
  }

  const ignoredFields = optionalFields ?? FORM_OPTIONAL_FIELDS;

  for (const [key, value] of Object.entries(form)) {
    if (ignoredFields.includes(key)) {
      continue;
    }

    if (!value) {
      return false;
    }
  }

  if (!validateSalaryCurrency(form)) {
    return false;
  }

  return true;
}
